import { DateRangePicker } from '@progress/kendo-react-dateinputs'
import { ExcelExport } from '@progress/kendo-react-excel-export'
import { Grid, GridColumn } from '@progress/kendo-react-grid'
import bodybuilder from 'bodybuilder'
import { LoadSegmentCodes } from 'components/common/load-partner-codes/component'
import { DropdownComponent} from 'components/dropdown/component'
import { HeaderComponent } from 'components/header/component'
import { Loading } from 'components/loading'
import { AggregationType, DateRangeFilter, FilterType, getMessageSendDateFilterField, IndexName,
  SuspectFilterDropdownOptions, ContentTypeFilterDropdownOptions, toFilter } from 'elasticsearch/constants'
import { DateRangesAsDropdownOptions } from 'elasticsearch/constants'
import { ResponseAggregate, ResponsePayload } from 'elasticsearch/types'
import { AjaxWrapper, HttpMethod } from 'generic/ajaxWrapper'
import {
  ElasticsearchComponent,
  ElasticsearchProps,
} from 'generic/elasticSearchComponent'
import * as GenericRedux from 'generic/genericRedux'
import * as React from 'react'
import { Button } from 'reactstrap'
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import { Chart, ChartSeries, ChartSeriesItem, ChartCategoryAxis, ChartCategoryAxisItem, ChartTitle } from '@progress/kendo-react-charts'
import { PDFReportHeader } from './PDFReportHeader'
import { DEFAULT_COMMUNITY_PARTNER_CODES } from 'shared_server_client/constants'
import { formatDate } from 'shared_server_client/dates'
import { Dataset } from 'generic/dataset'
import { SharedKeys, SharedStore } from 'shared/data-layer/sharedStore'
import { DropdownOption } from 'components/dropdown/component'
import * as Constants from './constants'
import { RasaAnalyticsComponent } from './rasa-analytics-component'
import './styles.css'
import * as Utils from './utils'
import { ConnectedComponentClass } from 'react-redux'
import { ComponentType } from 'react'
import {Fields} from "../../shared/modals";

export class ImagesClicksComponent extends RasaAnalyticsComponent<any, any> {
  private communityId: string = null

  constructor(props) {
    super(props)
    this.state = {
      selectedDateRange: DateRangesAsDropdownOptions[2],
      selectedSuspectClick: SuspectFilterDropdownOptions[0],
      selectedContentType: ContentTypeFilterDropdownOptions[0],
      selectedSegmentCode: DEFAULT_COMMUNITY_PARTNER_CODES.ALL,
      communityAdSources: [],
      selectedAdSource: { key: 'all', description: 'All Ad Sources' },
    }
  }

  public componentDidMount() {
    super.componentDidMount()
    this.minCustomDateRange()

    // Load community ad sources
    this.sharedStore = SharedStore.instance(this.context)
    this.sharedStore.getValue(SharedKeys.activeCommunity)
      .then((activeCommunity) => {
        this.communityId = activeCommunity.communityId
        return new Dataset().loadCommunityDataset('communityAdSources', this.communityId)
      })
      .then((adSources) => {
        const transformedAdSources = (adSources[0] || []).map((source: any) => ({
          key: source.id,
          description: source.name
        }))

        // Add "All" option at the beginning
        const allAdSources = [
          { key: 'all', description: 'All Ad Sources' },
          ...transformedAdSources
        ]

        this.setState({ communityAdSources: allAdSources })
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error('Failed to load community ad sources:', error)
      })
  }

  private contentTypeChanged = (e: any) => {
    this.setState({
      selectedContentType: e.selected,
    })
  }

  private adSourceChanged = (e: any) => {
    this.setState({
      selectedAdSource: e.selected,
    })
  }

  public render() {
    return (
      <div className="analytics-component">
        <HeaderComponent
          title={'ANALYTICS'}
          subTitle={'Images'}
          description={[
            'The image URLS your contacts are clicking on via banner and square images in your newsletter',
          ]}
        />
        <div className="dropdown">
          <div className="grid-container">
            <DropdownComponent data={DateRangesAsDropdownOptions}
                              selected={this.state.selectedDateRange.key}
                              onChange={this.dateChanged}/>
            <DropdownComponent data={SuspectFilterDropdownOptions}
                              selected={this.state.selectedSuspectClick.key}
                              onChange={this.suspectedClickChanged}/>
            <DropdownComponent data={ContentTypeFilterDropdownOptions}
                              selected={this.state.selectedContentType.key}
                              onChange={this.contentTypeChanged}/>
            {this.state.communityAdSources && this.state.communityAdSources.length > 1 && (
              <DropdownComponent data={this.state.communityAdSources}
                                selected={this.state.selectedAdSource.key}
                                onChange={this.adSourceChanged}/>
            )}
            <LoadSegmentCodes segmentCode={this.state.selectedSegmentCode} setSegmentCode={this.segmentCodeChanged}
              hideLabel={true}/>
          </div>
        </div>
        <div className="date-range-picker">
          {this.state.selectedDateRange.key === '7' ?
          <DateRangePicker min={this.state.minCustomDateRange}
                           max ={new Date()}
                           onChange={this.createCustomDate} /> : null}
        </div>
      {this.state.isFilterLoaded &&
        <AnalyticsImagesClickTable dateRange={this.state.selectedDateRange.value}
                dateRangeLabel={this.state.selectedDateRange.description}
                timezone={this.state.timezone}
                useTimezoneForAnalytics={this.state.useTimezoneForAnalytics}
                selectedSegmentCode={this.state.selectedSegmentCode}
                suspectClick={this.state.selectedSuspectClick.value}
                contentType={this.state.selectedContentType}
                selectedAdSource={this.state.selectedAdSource}/>}
      </div>
    )
  }

}

interface UrlStats {
  url: string,
  title?: string,
  totalClicks: number,
  uniqueClicks: number,
}

interface UrlInfo {
  url: string,
}

type Url = UrlStats & UrlInfo

type Urls = Url[]

interface ArticlesState {
  loaded: boolean,
  isLoadingData: boolean,
}

interface UrlProps extends ElasticsearchProps<Urls> {
  dateRange: any,
  suspectClick?: any,
  contentType?: any,
  selectedSegmentCode?: any,
  selectedAdSource?: DropdownOption,
  timezone?: string,
  useTimezoneForAnalytics?: any,
  dateRangeLabel?: string
}

const PRIMARY_AGG = 'primary_aggregation'
const TITLE_AGG = 'title'
const STATIC_IMAGE_AGG = 'static_image_id'
const NORMALIZED_CLICK_URL_FIELD = 'normalized_click_url.keyword'
const TITLE_KEYWORD_FIELD = 'title.keyword'
const EVENT_NAME_FIELD = 'event_name.keyword'
const COMMUNITY_PARTNER_CODE_FIELD = 'community_partner_code.keyword'
const MESSAGE_SEND_DATE_FIELD = 'message_send_date'
const RECORD_TYPE_FIELD = 'record_type'
const STATUS_FIELD = 'status'
const RECORD_ID_FIELD = 'record_id'
const COMMUNITY_PERSON_GUID_FIELD = 'community_person_guid.keyword'
const COMMUNITY_PERSON_ID_FIELD = 'community_person_id'
const COMMUNITY_AD_SOURCE_ID_FIELD = 'community_ad_source_id'

class ImagesClicksTableComponent extends ElasticsearchComponent<Urls, UrlProps, ArticlesState> {
  private xlsxExport: any = null
  private pdfExportRef: React.RefObject<HTMLDivElement> = React.createRef()
  constructor(p: UrlProps) {
    super(p, IndexName.EVENTS)
    this.state = {
      loaded: false,
      isLoadingData: false,
    }
    this.reportName = Constants.REPORT_NAMES.IMAGES
  }

  public parseResponse(payload: ResponsePayload): Promise<any> {
    const isImageType = this.props.contentType && this.props.contentType.value === 'image'

    if (isImageType) {
      return this.parseImageResponseComplete(payload)
    } else {
      return this.parseUrlResponseComplete(payload)
    }
   }

  private mapFinalResults(statsResponse: any[], openBuckets: any[], staticImageDetails: any[]): any[] {
    return statsResponse.map((a) => {
      const displayClickType: any = Utils.getDisplayedClickType(this.props.suspectClick)

      // For URL filter with collapsed rows, sum opens from all static images
      let opens = ''
      let uniqueOpens = ''

      if (a.all_static_image_ids && a.all_static_image_ids.length > 1) {
        // Multiple static images - sum up opens from all
        const allOpensRecords = openBuckets.filter((x) => a.all_static_image_ids.includes(Number(x.key)))
        const totalOpens = allOpensRecords.reduce((sum, record) => sum + (record[Constants.DOC_COUNT] || 0), 0)
        const totalUniqueOpens = allOpensRecords.reduce((sum, record) => sum + (record.unique.value || 0), 0)
        opens = totalOpens || ''
        uniqueOpens = totalUniqueOpens || ''
      } else {
        // Single static image or Image filter - use existing logic
        const opensRecord = openBuckets.filter((x) => Number(x.key) === a.static_image_id)
        opens = opensRecord.length ? opensRecord[0][Constants.DOC_COUNT] : ''
        uniqueOpens = opensRecord.length ? opensRecord[0].unique.value : ''
      }
      const staticImageInfo = this.staticImageInfoFor(a, staticImageDetails)

      const uniqueClickRate = uniqueOpens ? this.rateFormat((a.uniqueClicks / Number(uniqueOpens)) * 100) : ''
      const totalClickRate = opens ? this.rateFormat((a[displayClickType.field] / Number(opens)) * 100) : ''
      return ({
        ...a,
        opens,
        uniqueOpens,
        uniqueClickRate,
        totalClickRate,
        position: staticImageInfo.static_image_type ? staticImageInfo.static_image_type : '',
        title: staticImageInfo.title ? staticImageInfo.title : a.title,
        url: a.url ? a.url : staticImageInfo.url,
        startDate: staticImageInfo.start_date ? formatDate(staticImageInfo.start_date) : '',
        endDate: staticImageInfo.end_date ? formatDate(staticImageInfo.end_date) : '',
      })
    })
  }

  private parseImageResponse(clickedUrlAggregations: any, statsResponse: any[], staticImageIds: number[]): void {
    clickedUrlAggregations.buckets.map((aggregation: ResponseAggregate) => {
      // For image type, the key is static_image_id and there are no nested static_image buckets
      const staticImageId = aggregation.key ? Number(aggregation.key) : 0
      if (staticImageId && staticImageIds.indexOf(staticImageId) === -1) {
        staticImageIds.push(staticImageId)
      }

      if (!aggregation[TITLE_AGG] || !aggregation[TITLE_AGG].buckets || !aggregation[TITLE_AGG].buckets.length) {
        statsResponse.push({
          url: '', // No URL for image aggregation
          title: '',
          totalClicks: aggregation.doc_count,
          uniqueClicks: aggregation.unique.value,
          realClicks: aggregation.doc_count,
          static_image_id: staticImageId,
        })
      } else {
        const titleResponse = aggregation[TITLE_AGG].buckets.map((titleAggregation: ResponseAggregate) => {
          return ({
            url: '',
            title: titleAggregation.key,
            totalClicks: titleAggregation.doc_count,
            uniqueClicks: titleAggregation.unique.value,
            realClicks: titleAggregation.doc_count,
            static_image_id: staticImageId,
          })
        })
        const titleTotalClicks = titleResponse.reduce((accumulator, agg) => {
          return accumulator + agg.totalClicks
        }, 0);
        const titleUniqueClicks = titleResponse.reduce((accumulator, agg) => {
          return accumulator + agg.uniqueClicks
        }, 0);
        if (aggregation.doc_count !== titleTotalClicks) {
          statsResponse.push({
            url: '',
            title: '',
            totalClicks: aggregation.doc_count - titleTotalClicks,
            uniqueClicks: aggregation.unique.value - titleUniqueClicks,
            realClicks: aggregation.doc_count - titleTotalClicks,
            static_image_id: staticImageId,
          })
        }
        statsResponse.push(...titleResponse)
      }
    })
  }

  private parseUrlResponse(clickedUrlAggregations: any, statsResponse: any[], staticImageIds: number[]): void {
    clickedUrlAggregations.buckets.map((aggregation: ResponseAggregate) => {
      // For URL type, collect all static_image_ids for this URL but create only one record
      const staticImageBuckets = aggregation[STATIC_IMAGE_AGG] && aggregation[STATIC_IMAGE_AGG].buckets &&
      aggregation[STATIC_IMAGE_AGG].buckets.length ? aggregation[STATIC_IMAGE_AGG].buckets : []

      const urlStaticImageIds = []
      if (staticImageBuckets.length) {
        staticImageBuckets.map((staticImageBucket: ResponseAggregate) => {
          const staticImageId = staticImageBucket.key ? Number(staticImageBucket.key) : 0
          if (staticImageId) {
            if (staticImageIds.indexOf(staticImageId) === -1) {
              staticImageIds.push(staticImageId)
            }
            urlStaticImageIds.push(staticImageId)
          }
        })
      } else {
        urlStaticImageIds.push(0)
      }

      // Use the first static_image_id for the record, but track all IDs and count
      const primaryStaticImageId = urlStaticImageIds[0] || 0
      const staticImageCount = urlStaticImageIds.length
      const allStaticImageIds = urlStaticImageIds

      if (!aggregation[TITLE_AGG] || !aggregation[TITLE_AGG].buckets || !aggregation[TITLE_AGG].length) {
        statsResponse.push({
          url: aggregation.key,
          title: '',
          totalClicks: aggregation.doc_count,
          uniqueClicks: aggregation.unique.value,
          realClicks: aggregation.doc_count,
          static_image_id: primaryStaticImageId,
          static_image_count: staticImageCount,
          all_static_image_ids: allStaticImageIds,
        })
      } else {
        const titleResponse = aggregation.child.buckets.map((titleAggregation: ResponseAggregate) => {
          return ({
            url: aggregation.key,
            title: titleAggregation.key,
            totalClicks: titleAggregation.doc_count,
            uniqueClicks: titleAggregation.unique.value,
            realClicks: titleAggregation.doc_count,
            static_image_id: primaryStaticImageId,
            static_image_count: staticImageCount,
            all_static_image_ids: allStaticImageIds,
          })
        })
        const titleTotalClicks = titleResponse.reduce((accumulator, agg) => {
          return accumulator + agg.totalClicks
        }, 0);
        const titleUniqueClicks = titleResponse.reduce((accumulator, agg) => {
          return accumulator + agg.uniqueClicks
        }, 0);
        if (aggregation.doc_count !== titleTotalClicks) {
          statsResponse.push({
            url: aggregation.key,
            title: '',
            totalClicks: aggregation.doc_count - titleTotalClicks,
            uniqueClicks: aggregation.unique.value - titleUniqueClicks,
            realClicks: aggregation.doc_count - titleTotalClicks,
            static_image_id: primaryStaticImageId,
            static_image_count: staticImageCount,
            all_static_image_ids: allStaticImageIds,
          })
        }
        statsResponse.push(...titleResponse)
      }
    })
  }

  private parseImageResponseComplete(payload: ResponsePayload): Promise<any> {
    const clickedUrlAggregations = payload.aggregations[PRIMARY_AGG]
    const statsResponse = []
    const staticImageIds: number[] = []

    this.parseImageResponse(clickedUrlAggregations, statsResponse, staticImageIds)

    return this.getOpens(staticImageIds.map(String)).then((result) => {
      const openAggregations = result.aggregations ? result.aggregations[PRIMARY_AGG] : {}
      const openBuckets = openAggregations.buckets ? openAggregations.buckets : []

      return this.getStaticImagesDetails(staticImageIds.map(String)).then((staticImageDetails: any[]) => {
        this.setState({
          loaded: true,
          isLoadingData: false,
        })
        return this.mapFinalResults(statsResponse, openBuckets, staticImageDetails)
      })
    })
  }

  private parseUrlResponseComplete(payload: ResponsePayload): Promise<any> {
    const clickedUrlAggregations = payload.aggregations[PRIMARY_AGG]
    const statsResponse = []
    const staticImageIds: number[] = []

    this.parseUrlResponse(clickedUrlAggregations, statsResponse, staticImageIds)

    return this.getOpens(staticImageIds.map(String)).then((result) => {
      const openAggregations = result.aggregations ? result.aggregations[PRIMARY_AGG] : {}
      const openBuckets = openAggregations.buckets ? openAggregations.buckets : []

      return this.getStaticImagesDetails(staticImageIds.map(String)).then((staticImageDetails: any[]) => {
        this.setState({
          loaded: true,
          isLoadingData: false,
        })
        return this.mapFinalResults(statsResponse, openBuckets, staticImageDetails)
      })
    })
  }

  public componentDidUpdate(oldProps: UrlProps) {
    if ( this.props.dateRange !== oldProps.dateRange || this.props.suspectClick !== oldProps.suspectClick
      || this.props.selectedSegmentCode !== oldProps.selectedSegmentCode
      || this.props.contentType !== oldProps.contentType
      || this.props.selectedAdSource !== oldProps.selectedAdSource ) {
      this.setState({ isLoadingData: true })
      this.search()
    }
  }

  public searchPayload(): any {
    const dateRangeFilter: DateRangeFilter = toFilter(this.props.dateRange, this.props.timezone, this.props.useTimezoneForAnalytics)
    if (dateRangeFilter.gte && dateRangeFilter.lt) {
      const search = bodybuilder().size(0)
        .filter(FilterType.range, getMessageSendDateFilterField(this.props.dateRange, this.props.useTimezoneForAnalytics), dateRangeFilter)
        .filter(FilterType.term, EVENT_NAME_FIELD, 'click')
        .filter(FilterType.exists, 'static_image_id')
        .notFilter(FilterType.exists, 'post_subscription_id')
        .notFilter(FilterType.exists, 'community_promotion_id')
      if (this.props.suspectClick && Utils.isRealClickSelected(this.props.suspectClick)) {
        search.addFilter(FilterType.term, 'suspect_click', 0)
      }

      if (this.props.selectedSegmentCode === DEFAULT_COMMUNITY_PARTNER_CODES.NO_CODE) {
        search.notFilter(FilterType.exists, COMMUNITY_PARTNER_CODE_FIELD)
      } else if (this.props.selectedSegmentCode !== DEFAULT_COMMUNITY_PARTNER_CODES.ALL) {
        search.filter(FilterType.term, COMMUNITY_PARTNER_CODE_FIELD, this.props.selectedSegmentCode)
      }

      // Add ad source filter
      if (this.props.selectedAdSource && this.props.selectedAdSource.key !== 'all') {
        search.filter(FilterType.term, COMMUNITY_AD_SOURCE_ID_FIELD, this.props.selectedAdSource.key)
      }
      const isImageType = this.props.contentType && this.props.contentType.value === 'image'
      const primaryField = isImageType ? STATIC_IMAGE_AGG : NORMALIZED_CLICK_URL_FIELD
      const childAggregations = isImageType ? [{
        field: TITLE_KEYWORD_FIELD,
        name: TITLE_AGG,
        type: AggregationType.terms,
        unique_on: COMMUNITY_PERSON_ID_FIELD,
        extra: { size: '100' },
      }] : [{
        field: TITLE_KEYWORD_FIELD,
        name: TITLE_AGG,
        type: AggregationType.terms,
        unique_on: COMMUNITY_PERSON_ID_FIELD,
        extra: { size: '100' },
      }, {
        type: AggregationType.terms,
        field: STATIC_IMAGE_AGG,
        name: STATIC_IMAGE_AGG,
        unique_on: COMMUNITY_PERSON_GUID_FIELD,
      }]

      return this.addAggregation(search, {
        type: AggregationType.terms,
        field: primaryField,
        name: PRIMARY_AGG,
        extra: { size: '100' },
        unique_on: isImageType ? COMMUNITY_PERSON_GUID_FIELD : COMMUNITY_PERSON_ID_FIELD,
        childs: childAggregations,
      }).build()
    }
  }

  public exportToPDF = async () => {
    if (!this.pdfExportRef.current) return

    try {
      const element = this.pdfExportRef.current

      // Temporarily add PDF export mode class to show PDF elements
      element.classList.add('pdf-export-mode')

      // Wait a brief moment for styles to apply
      await new Promise(resolve => setTimeout(resolve, 100))

      const pdf = new jsPDF('l', 'mm', 'a4') // landscape orientation
      const pdfWidth = pdf.internal.pageSize.getWidth()
      const pdfHeight = pdf.internal.pageSize.getHeight()

      // Capture header and chart separately (Page 1)
      const headerChart = element.querySelector('.pdf-header-chart-section')
      if (headerChart) {
        const headerCanvas = await html2canvas(headerChart as HTMLElement, {
          height: headerChart.scrollHeight,
          width: headerChart.scrollWidth,
          useCORS: true,
          scale: 2
        })

        const headerImgData = headerCanvas.toDataURL('image/png')
        const headerRatio = Math.min(pdfWidth / headerCanvas.width, pdfHeight / headerCanvas.height)
        const headerImgX = (pdfWidth - headerCanvas.width * headerRatio) / 2

        pdf.addImage(headerImgData, 'PNG', headerImgX, 10, headerCanvas.width * headerRatio, headerCanvas.height * headerRatio)
      }

      // Capture table separately (Page 2+)
      if (this.props.results && this.props.results.length > 0) {
        const itemsPerPage = 10
        const totalPages = Math.ceil(this.props.results.length / itemsPerPage)

        for (let page = 0; page < totalPages; page++) {
          pdf.addPage()

          // Add page header
          pdf.setFontSize(16)
          pdf.text(`Images Report - Page ${page + 2} of ${totalPages + 1}`, 20, 20)
          pdf.setFontSize(12)
          pdf.text(`Showing entries ${page * itemsPerPage + 1} - ${Math.min((page + 1) * itemsPerPage, this.props.results.length)} of ${this.props.results.length}`, 20, 30)

          // Create table data for this page
          const pageData = this.props.results.slice(page * itemsPerPage, (page + 1) * itemsPerPage)

          // Simple table rendering
          let yPosition = 50
          const rowHeight = 10
          const colPositions = [20, 100, 140, 180, 220, 260]

          // Table headers
          pdf.setFontSize(9)
          pdf.setFont(undefined, 'bold')
          pdf.text('Title', colPositions[0], yPosition)
          pdf.text('Position', colPositions[1], yPosition)
          pdf.text('Opens', colPositions[2], yPosition)
          pdf.text('Total Clicks', colPositions[3], yPosition)
          pdf.text('Unique Clicks', colPositions[4], yPosition)
          pdf.text('Click Rate', colPositions[5], yPosition)
          yPosition += rowHeight + 2

          // Table rows
          pdf.setFont(undefined, 'normal')
          pageData.forEach((item: any) => {
            if (yPosition > pdfHeight - 20) return // Stop if near bottom of page

            pdf.text(item.title ? item.title.substring(0, 30) : 'N/A', colPositions[0], yPosition)
            pdf.text(item.position ? item.position.substring(0, 15) : 'N/A', colPositions[1], yPosition)
            pdf.text((item.opens || 0).toString(), colPositions[2], yPosition)
            pdf.text((item.totalClicks || 0).toString(), colPositions[3], yPosition)
            pdf.text((item.uniqueClicks || 0).toString(), colPositions[4], yPosition)
            pdf.text(item.uniqueClickRate ? item.uniqueClickRate.toString() : '0%', colPositions[5], yPosition)
            yPosition += rowHeight
          })
        }
      }

      // Remove PDF export mode class
      element.classList.remove('pdf-export-mode')

      pdf.save('images-report.pdf')
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error generating PDF:', error)
      // Make sure to remove the class even if there's an error
      if (this.pdfExportRef.current) {
        this.pdfExportRef.current.classList.remove('pdf-export-mode')
      }
    }
  }

  public render = () => {
    const displayClickType: any = Utils.getDisplayedClickType(this.props.suspectClick)
    const isImageFilter = this.props.contentType && this.props.contentType.value === 'image'
    return <div>
      <div className="articles-chart">
        {this.state.isLoadingData ? (
          <div style={{ textAlign: 'center', padding: '40px' }}>
            <Loading size="32" />
          </div>
        ) : (this.state.loaded && this.props.results && this.props.results.length > 0 ?
        <div className="other-clicks">
          <div className="articles-export-buttons">
            <Button
              disabled={this.props.results.length < 1 || this.state.isLoadingData}
              onClick={() => this.xlsxExport.save()}>
              Export xlsx
            </Button>
            <Button
              color="secondary"
              disabled={this.props.results.length < 1 || this.state.isLoadingData}
              onClick={this.exportToPDF}>
              Export PDF
            </Button>
          </div>
          <div ref={this.pdfExportRef}>
            <div className="pdf-header-chart-section">
              <PDFReportHeader
                title="Images Report"
                dateRange={this.props.dateRange}
                dateRangeLabel={this.props.dateRangeLabel}
                fields={[
                  { label: 'Suspect Click Filter', value: displayClickType.title },
                  { label: 'Segment Code', value: this.props.selectedSegmentCode || 'All' },
                ]}
                analysis="Image click performance and engagement metrics"
              />

              {this.props.results && this.props.results.length > 0 && (
                <div className="pdf-chart-section">
                  <h3>Top 20 Images - Total vs Unique Clicks</h3>
                  <Chart style={{ height: '400px' }}>
                    <ChartTitle text="Image Performance Comparison" />
                    <ChartCategoryAxis>
                      <ChartCategoryAxisItem
                        categories={this.props.results.slice(0, 20).map((item: any, index: number) =>
                          item.title ? item.title.substring(0, 20) + '...' : `Image ${index + 1}`
                        )}
                        labels={{ rotation: -45 }}
                      />
                    </ChartCategoryAxis>
                    <ChartSeries>
                      <ChartSeriesItem
                        type="column"
                        data={this.props.results.slice(0, 20).map((item: any) => item.totalClicks || 0)}
                        name="Total Clicks"
                        color="#8fd1bb"
                      />
                      <ChartSeriesItem
                        type="column"
                        data={this.props.results.slice(0, 20).map((item: any) => item.uniqueClicks || 0)}
                        name="Unique Clicks"
                        color="#fcc3a7"
                      />
                    </ChartSeries>
                  </Chart>
                </div>
              )}
            </div>

            <div className="pdf-table-section">
              <h3>Detailed Image Performance</h3>
            </div>
          </div>
          <ExcelExport data={this.props.results}
            fileName="RasaAdminReports.xlsx"
            ref={(exporter) => {this.xlsxExport = exporter}}>
            <Grid data={this.props.results} className="analytics-counts-grid">
              <GridColumn field="title" title="Title" width={200}/>
              <GridColumn field="position" title="Position" width={100}/>
              <GridColumn field="url" title="Url" width={500}/>
              <GridColumn field="startDate" title="Start Date" width={0}/>
              <GridColumn field="endDate" title="End Date" width={0}/>
              <GridColumn field="opens" title="Opens" width={80}/>
              <GridColumn field="uniqueOpens" title="Unique Opens" width={0}/>
              <GridColumn field={displayClickType.field} title={displayClickType.title} width={120}/>
              <GridColumn field="uniqueClicks" title="Unique Clicks" width={150}/>
              <GridColumn field="uniqueClickRate" title="Unique Click Rate" width={150}/>
              <GridColumn field="totalClickRate" title={`${displayClickType.title} Rate`} width={0}/>
              {!isImageFilter && <GridColumn field="static_image_count" title="# Images" width={120}/>}
            </Grid>
          </ExcelExport>
        </div> :
        <div>
          <p className="no-data-tag">
            {Constants.NO_DATA_COPY}
          </p>
        </div>)}
      </div>
    </div>
  }

  private rateFormat = (value: number) => {
    return `${value.toFixed(2)}%`
  }

  private staticImageInfoFor = (a: any, staticImages: any[]): any => {
    const hit = staticImages.find((p) => p.id === a.static_image_id)
    return hit ? hit : {}
  }

  private getOpens = (staticImageIds: string[]): Promise<any> => {
    if (staticImageIds.length) {
      const dateRangeFilter: DateRangeFilter = toFilter(this.props.dateRange, this.props.timezone, this.props.useTimezoneForAnalytics)
      if (dateRangeFilter.gte && dateRangeFilter.lt) {

        const search = bodybuilder().size(0)
          .filter(FilterType.range, MESSAGE_SEND_DATE_FIELD, dateRangeFilter)
          .filter(FilterType.terms, RECORD_ID_FIELD, staticImageIds)
          .filter(FilterType.term, RECORD_TYPE_FIELD, 'image')
          .filter(FilterType.term, STATUS_FIELD, 'open')

        const payload = this.addAggregation(search, {
          type: AggregationType.terms,
          field: RECORD_ID_FIELD,
          name:  PRIMARY_AGG,
          extra: { size: staticImageIds.length.toString() },
          unique_on: COMMUNITY_PERSON_ID_FIELD,
        })

        const query = payload.build()
        return this.queryIndex(query, IndexName.MESSAGE_RUN_DETAIL)
      }
    }
    return Promise.resolve({})
  }

  private getStaticImagesDetails = (imageIds: string[]): Promise<any[]> => {
    if (imageIds.length) {
      const url: string = AjaxWrapper.getServerUrl() + `/dataset/${this.communityId}/staticImagesByIds`
      const payload = {
        imageIds: imageIds.join(','),
      }
      return AjaxWrapper.ajax(url, HttpMethod.POST, payload)
      .then((response: any[]) => {
        return response[0]
      })
      .catch(() => ([]))
    } else {
      return Promise.resolve([])
    }
  }
}

export const AnalyticsImagesClickTable: ConnectedComponentClass<ComponentType<ImagesClicksTableComponent>, Fields> = GenericRedux.registerNewComponent(
  ImagesClicksTableComponent,
  'home_urls',
  {},
)
